import { render, staticRenderFns } from "./CabinetBonuses.vue?vue&type=template&id=669dc4c8&lang=pug&"
import script from "./CabinetBonuses.vue?vue&type=script&lang=js&"
export * from "./CabinetBonuses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports